// Include the different bits needed in this page
// @codekit-prepend "./util/util"

let Press = {

    sliderTitle : document.querySelector('.slider-home-text'),

    // Liftoff Function
    liftoff : function() {
        this.initSliderLatest();
    },



    // Latest news slider
    initSliderLatest : function(){

        var elem = document.querySelector('.press-news-slider');
        var flkty = new Flickity( elem, {
            
            // options
            //cellAlign       : 'center',
            contain         : false,
            cellSelector    : '.press-news-slide',
            pageDots        : false,
            prevNextButtons : true,
            imagesLoaded    : true,
            arrowShape      : "m68.8425277 0 3.6572417 3.25574375L33.8455689 49.9975485l38.6542807 46.7469016L68.8424476 100 28.8460709 51.6253234l-1.3459205-1.6278591 1.3460006-1.6277877z"

        });

    }
};

Press.liftoff();